/**
 * CJSUSPENSION Vorsprung Fractive + Tractive preview fixes.
 * Runs once per page load (plus safe delayed retries) to correct stale Shopify
 * resource-preview settings without continuously observing/mutating the DOM.
 */
(function () {
  'use strict';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function setHTML(el, value) {
    if (el && el.innerHTML !== value) el.innerHTML = value;
  }

  function setButton(el, label, href) {
    if (!el) return;
    setText(el, label);
    if (el.getAttribute('href') !== href) el.setAttribute('href', href);
  }

  function sectionWithHeading(root, phrase) {
    var sections = root.querySelectorAll('.cjs-upgrade-section');
    for (var i = 0; i < sections.length; i += 1) {
      var h = sections[i].querySelector('.cjs-upgrade-section-head h2');
      if (h && clean(h.textContent).indexOf(clean(phrase)) !== -1) return sections[i];
    }
    return null;
  }

  function fixFractive(root, hero) {
    if (root.getAttribute('data-cjs-fractive-finalized') === 'true') return;

    setText(hero.querySelector('.cjs-upgrade-eyebrow'), 'Vorsprung Fractive Tuning System');
    setText(hero.querySelector('h1'), 'Vorsprung Fractive Tuning System');
    setHTML(hero.querySelector('.cjs-upgrade-hero-text'), '<p>Fractive upgrades the compression side of a compatible Fox FIT4 damper with Vorsprung\'s high-performance compression piston, custom compression valving and true high-speed compression control.</p>');

    var heroButtons = hero.querySelectorAll('.cjs-upgrade-button-row a');
    setButton(heroButtons[0], 'Book Fractive Tuning', '/pages/book-a-suspension-service');
    setButton(heroButtons[1], 'Shop Fractive', '/products/vorsprung-fractive-tuning-kit');

    var trustCards = root.querySelectorAll('.cjs-upgrade-trust-card');
    var trust = [
      ['Custom Valving', 'Compression tune tailored to rider requirements'],
      ['True HSC Control', '3-position switch becomes high-speed compression adjustment'],
      ['LSC Remains Active', 'Low-speed compression works in every HSC mode'],
      ['Support + Compliance', 'Support where you need it, compliance where you don\'t']
    ];
    for (var i = 0; i < trustCards.length && i < trust.length; i += 1) {
      setText(trustCards[i].querySelector('strong'), trust[i][0]);
      setText(trustCards[i].querySelector('span'), trust[i][1]);
    }

    var faq = sectionWithHeading(root, 'Fractive FAQs');
    if (faq) faq.remove();

    root.setAttribute('data-cjs-fractive-finalized', 'true');
  }

  function fixTractive(root, hero) {
    if (root.getAttribute('data-cjs-tractive-finalized') === 'true') return;

    setText(hero.querySelector('.cjs-upgrade-eyebrow'), 'Vorsprung Tractive Valve Tuning System');
    setText(hero.querySelector('h1'), 'Vorsprung Tractive Valve Tuning System');
    setHTML(hero.querySelector('.cjs-upgrade-hero-text'), '<p>Tractive combines tune calculation, upgraded damper hardware and custom compression and rebound valving to match a compatible RockShox rear shock to the rider, bike and terrain.</p>');

    var heroButtons = hero.querySelectorAll('.cjs-upgrade-button-row a');
    setButton(heroButtons[0], 'Book Tractive Tuning', '/pages/book-a-suspension-service');
    setButton(heroButtons[1], 'Shop Tractive', '/products/tractive-upgrade-kit');

    var summary = root.querySelector('.cjs-upgrade-summary');
    if (summary) {
      setText(summary.querySelector('h2'), 'Tractive at a Glance');
      var values = summary.querySelectorAll('.cjs-upgrade-summary-item span');
      if (values[0]) setText(values[0], 'Custom rear-shock valve tuning process');
      if (values[1]) setText(values[1], 'RockShox Super Deluxe Air and Coil RC, RC3, RCT and RTR applications, plus Monarch Plus RC3. Exact shock generation must be confirmed.');
      if (values[2]) setText(values[2], 'Tune selection considers rider weight, bike leverage, terrain, aggression and preference.');
    }

    var trustCards = root.querySelectorAll('.cjs-upgrade-trust-card');
    var trust = [
      ['Custom Tune Selection', 'Frame, weight, terrain, aggression and preference'],
      ['Triple-Circuit Base Valve', 'Upgraded compression base valve assembly'],
      ['Pressure-Balanced Valving', 'Sensitivity and support without cavitation'],
      ['Custom Rebound Valving', 'Rebound tune matched with the compression setup']
    ];
    for (var i = 0; i < trustCards.length && i < trust.length; i += 1) {
      setText(trustCards[i].querySelector('strong'), trust[i][0]);
      setText(trustCards[i].querySelector('span'), trust[i][1]);
    }

    var featureGrid = root.querySelector('.cjs-upgrade-feature-grid');
    if (featureGrid) {
      var section = featureGrid.closest('.cjs-upgrade-section');
      if (section) {
        setText(section.querySelector('.cjs-upgrade-kicker'), 'Tractive tuning process');
        setText(section.querySelector('.cjs-upgrade-section-head h2'), 'What the Tractive Tuning System Changes');
        setHTML(section.querySelector('.cjs-upgrade-section-copy'), '<p>Vorsprung developed Tractive as a process, not a single replacement part. Tune calculation, damper architecture, compression valving, rebound valving and adjustment range are considered together.</p>');
      }

      var cards = featureGrid.querySelectorAll('.cjs-upgrade-feature');
      if (cards[0]) {
        setText(cards[0].querySelector('.cjs-upgrade-feature-label'), 'Tune calculation');
        setText(cards[0].querySelector('h3'), 'Rider, Bike & Terrain');
        setHTML(cards[0].querySelector('.rte'), '<p>Vorsprung\'s Tractive calculation process considers rider weight, the bike\'s leverage rate and the damper curve, with the tune selected around the rider, frame and terrain.</p>');
      }
      if (cards[1]) {
        setText(cards[1].querySelector('.cjs-upgrade-feature-label'), 'Compression system');
        setText(cards[1].querySelector('h3'), 'Triple-Circuit Base Valve');
        setHTML(cards[1].querySelector('.rte'), '<p>The upgraded compression base valve uses triple-circuit technology and gives the three-position compression adjuster more usable, evenly spaced settings.</p>');
      }
      if (cards[2]) {
        setText(cards[2].querySelector('.cjs-upgrade-feature-label'), 'Compression + rebound');
        setText(cards[2].querySelector('h3'), 'Pressure-Balanced Custom Valving');
        setHTML(cards[2].querySelector('.rte'), '<p>Pressure-balanced compression valving is combined with customised rebound valving to provide sensitivity and support without cavitation.</p>');
      }
    }

    var split = root.querySelector('.cjs-upgrade-split');
    if (split) {
      var details = split.querySelectorAll(':scope > .cjs-upgrade-detail');
      if (details[0]) {
        setText(details[0].querySelector('.cjs-upgrade-kicker'), 'Fitment first');
        setText(details[0].querySelector('h2'), 'RockShox Shock Compatibility');
        setHTML(details[0].querySelector('.rte'), '<p>CJSUSPENSION supports Tractive for compatible RockShox Super Deluxe Air and Coil RC, RC3, RCT and RTR applications, plus Monarch Plus RC3.</p><p>The exact shock generation, mount configuration and frame application must be confirmed before tuning.</p><p><a href="/products/tractive-upgrade-kit" style="display:inline-block;margin:0 7px 9px 0;padding:10px 16px;border-radius:7px;background:#111;color:#fff;text-decoration:none;font-weight:800">SHOP TRACTIVE</a></p>');
      }
      if (details[1]) {
        setText(details[1].querySelector('.cjs-upgrade-kicker'), 'CJSUSPENSION tuning');
        setText(details[1].querySelector('h2'), 'Full Service, Tractive Installation & Tune');
        setHTML(details[1].querySelector('.rte'), '<ul><li>Confirm the exact shock, bike and frame application</li><li>Review rider weight, terrain, aggression, preference and current setup</li><li>Strip, inspect and fully service the shock</li><li>Install the supported Tractive hardware and custom compression and rebound valving</li><li>Vacuum bleed and nitrogen charge the damper</li><li>Set practical baseline adjustments and function-check the shock</li></ul>');
      }
    }

    var owner = root.querySelector('#existing-owner-support');
    if (owner) {
      setText(owner.querySelector('.cjs-upgrade-section-head .cjs-upgrade-kicker'), 'Already have Tractive installed?');
      setText(owner.querySelector('.cjs-upgrade-section-head h2'), 'Tractive Service & Tune Support');
      setHTML(owner.querySelector('.cjs-upgrade-section-head .cjs-upgrade-section-copy'), '<p>We can service a supported Tractive-equipped shock, review the current tune and update the setup when the rider, bike or riding requirements change.</p>');

      var support = owner.querySelectorAll('.cjs-upgrade-support-card');
      if (support[0]) {
        setText(support[0].querySelector('h3'), 'Full Shock Service');
        setHTML(support[0].querySelector('.rte'), '<p>The shock is stripped, inspected, serviced, vacuum bled and nitrogen charged with the Tractive hardware and valving checked during the rebuild.</p>');
      }
      if (support[1]) {
        setText(support[1].querySelector('h3'), 'Tune Review');
        setHTML(support[1].querySelector('.rte'), '<p>Rider feedback, bike setup and the balance between compression and rebound are reviewed before any supported valving change is made.</p>');
      }
      if (support[2]) {
        setText(support[2].querySelector('h3'), 'Spring & Volume Setup');
        setHTML(support[2].querySelector('.rte'), '<p>Spring pressure, coil spring rate and air-volume spacer setup can be reviewed alongside the damper tune where changes are required.</p>');
      }
    }

    var productSection = sectionWithHeading(root, 'Tractive Valve Tuning System');
    if (productSection && productSection.querySelector('#products-and-tools, .cjs-upgrade-resource-grid')) {
      productSection.remove();
    }

    var faq = sectionWithHeading(root, 'Tractive FAQs');
    if (faq) faq.remove();

    var finalPanel = root.querySelector('.cjs-upgrade-final');
    if (finalPanel) {
      setText(finalPanel.querySelector('.cjs-upgrade-kicker'), 'Ready to tune your RockShox rear shock?');
      setText(finalPanel.querySelector('h2'), 'Book Your Tractive Tune');
      setHTML(finalPanel.querySelector('.rte'), '<p>Provide the bike, shock, rider weight and riding information so CJSUSPENSION can confirm compatibility and select the supported Tractive setup before the shock is opened.</p>');
      var finalButtons = finalPanel.querySelectorAll('.cjs-upgrade-button-row a');
      setButton(finalButtons[0], 'Book Tractive Tuning', '/pages/book-a-suspension-service');
      setButton(finalButtons[1], 'Shop Tractive', '/products/tractive-upgrade-kit');
    }

    root.setAttribute('data-cjs-tractive-finalized', 'true');
  }

  function run() {
    var root = document.querySelector('.cjs-upgrade-page');
    var hero = root && root.querySelector('.cjs-upgrade-hero');
    if (!root || !hero) return;

    var text = clean((hero.querySelector('h1') ? hero.querySelector('h1').textContent : '') + ' ' + (hero.querySelector('.cjs-upgrade-hero-text') ? hero.querySelector('.cjs-upgrade-hero-text').textContent : ''));
    if (text.indexOf('fractive') !== -1) fixFractive(root, hero);
    if (text.indexOf('tractive') !== -1 && text.indexOf('fractive') === -1) fixTractive(root, hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.setTimeout(run, 350);
  window.setTimeout(run, 1200);
  document.addEventListener('shopify:section:load', run);
})();
